import React, { useState, useEffect, use } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { getAllCompanyCodes } from "../Api/CompanyLocationMaster";
import { insertAchd } from "../Api/Reconciliation";
import { getAllBankStatements } from "../Api/BankStatements";
import { getAllHouseBanks } from "../Api/HouseBank";
import { useAuth } from "../Context/AuthContext";
const StplTransferReconciliation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { monthId, houseBankId } = useParams(); // ✅ get from URL
  const [houseBanks, setHouseBanks] = useState([]);
  const {user}=useAuth();
  // ✅ Get current logged-in user
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId || "system";

  // Fetch house banks
  useEffect(() => {
    const fetchHouseBanks = async () => {
      try {
        const res = await getAllHouseBanks(user?.organisationId);
        setHouseBanks(res || []);
      } catch (err) {
        console.error("Error fetching house banks:", err);
      }
    };
    fetchHouseBanks();
  }, []);

  const { statement } = location.state || {};

  const [companies, setCompanies] = useState([]);
  const [formData, setFormData] = useState({
    transferType: "I4",
    transferFrom: "",
    transferFromCompanyCode: "",
    transferTo: "",
    transferToCompanyCode: "",
    amount: statement?.transactionAmount || "",
    currency: "INR",
    remarks: "",
  });

  // Fetch company codes
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await getAllCompanyCodes();
        setCompanies(res || []); // ensure array
      } catch (err) {
        console.error("Error fetching company codes:", err);
      }
    };
    fetchCompanies();
  }, []);

  // Fetch house banks
  useEffect(() => {
    const fetchHouseBanks = async () => {
      try {
        const res = await getAllHouseBanks();
        setHouseBanks(res || []);
      } catch (err) {
        console.error("Error fetching house banks:", err);
      }
    };
    fetchHouseBanks();
  }, []);

  // Auto-fill transferFrom/transferTo based on CR/DR
  // useEffect(() => {
  //   if (statement) {
  //     const bankInfo = `${statement.housebankId} - ${statement.bankName} - ${statement.accountNumber}`;
  //     if (statement.creditDebit === "CR") {
  //       setFormData((prev) => ({ ...prev, transferTo: bankInfo }));
  //     } else if (statement.creditDebit === "DR") {
  //       setFormData((prev) => ({ ...prev, transferFrom: bankInfo }));
  //     }
  //   }
  // }, [statement]);

  useEffect(() => {
    if (statement) {
      if (statement.creditDebit === "CR") {
        setFormData((prev) => ({ ...prev, transferTo: statement.housebankId }));
      } else if (statement.creditDebit === "DR") {
        setFormData((prev) => ({
          ...prev,
          transferFrom: statement.housebankId,
        }));
      }
    }
  }, [statement]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   const getAccountNumber = (val) => val?.split(" - ")[2] || "";

  //   let newFormData = {
  //     ...formData,
  //     [name]: value,
  //   };

  //   const fromAcc = getAccountNumber(
  //     name === "transferFrom" ? value : formData.transferFrom
  //   );
  //   const toAcc = getAccountNumber(
  //     name === "transferTo" ? value : formData.transferTo
  //   );

  //   // ❌ if same account number, reset the last changed field
  //   if (fromAcc && toAcc && fromAcc === toAcc) {
  //     alert(
  //       "❌ Transfer From and Transfer To cannot have the same Account Number."
  //     );

  //     // reset only the last changed field
  //     newFormData[name] = "";
  //   }

  //   setFormData(newFormData);
  // };

  const handleChange = (e) => {
  const { name, value } = e.target;

  let newFormData = { ...formData, [name]: value };

  const isInternal = formData.transferType === "I4"; // INTERNAL

  const fromHB = houseBanks.find(
    (hb) =>
      hb.housebankId ===
      (name === "transferFrom" ? value : formData.transferFrom)
  );
  const toHB = houseBanks.find(
    (hb) =>
      hb.housebankId ===
      (name === "transferTo" ? value : formData.transferTo)
  );

  const fromAcc = fromHB?.accountNumber;
  const toAcc = toHB?.accountNumber;

  // -----------------------------
  // 🔹 1. ACCOUNT VALIDATION
  // -----------------------------
  if (!isInternal) {
    // 👎 External transfer → SAME ACCOUNT NOT ALLOWED
    if (fromAcc && toAcc && fromAcc === toAcc) {
      alert("❌ Transfer From and Transfer To cannot have the same Account Number for EXTERNAL transfers.");
      newFormData[name] = "";
    }
  }
  // INTERNAL: skip validation → same account allowed ✔️

  // -----------------------------
  // 🔹 2. COMPANY CODE VALIDATION
  // -----------------------------
  const fromCompany =
    name === "transferFromCompanyCode"
      ? value
      : formData.transferFromCompanyCode;

  const toCompany =
    name === "transferToCompanyCode"
      ? value
      : formData.transferToCompanyCode;

  if (!isInternal) {
    // 👎 External transfer → SAME COMPANY CODE NOT ALLOWED
    if (fromCompany && toCompany && fromCompany === toCompany) {
      alert("❌ Same company code not allowed for EXTERNAL transfers.");
      newFormData[name] = "";
    }
  }
  // INTERNAL: skip validation → same company allowed ✔️

  setFormData(newFormData);
};


  const getWeekNumber = (date) => {
    const d = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    const dayNum = d.getUTCDay() || 7; // Sunday = 0, fix to 7
    d.setUTCDate(d.getUTCDate() + 4 - dayNum); // nearest Thursday
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const now = new Date();
  //   const currentYear = now.getFullYear().toString();
  //   const currentMonthMinus2 = (now.getMonth() + 1 - 2 + 12) % 12 || 12;
  //   const currentWeek = getWeekNumber(now);

  //   const payload = {
  //     transferType: formData.transferType,
  //     statementId: statement.statementId,
  //     docfy: currentYear,
  //     recoAmount: String(statement.transactionAmount),
  //     recoCurrency: formData.currency,
  //     transferFromCompanyCode: formData.transferFromCompanyCode,
  //     transferToCompanyCode: formData.transferToCompanyCode,
  //     remarks: formData.remarks,
  //     document_Type: formData.transferType,
  //     achdData: [
  //       {
  //         docfy: parseInt(currentYear), // or Number(currentYear)
  //         docfm: parseInt(currentMonthMinus2), // or Number(currentMonthMinus2)
  //         doccc:
  //           statement.creditDebit === "DR"
  //             ? formData.transferFromCompanyCode
  //               ? parseInt(formData.transferFromCompanyCode)
  //               : null
  //             : formData.transferToCompanyCode
  //             ? parseInt(formData.transferToCompanyCode)
  //             : null,

  //         postingDate: statement.transactionPostedDate,
  //         documentDate: statement.valueDate,
  //         refNo: statement.statementId,
  //         createdOn: now.toISOString(),
  //         enteredBy: String(userId),
  //         documentType: formData.transferType,
  //         approvalStatus: null,
  //         utrNumber: "",
  //         utrUpdatedBy: "",
  //         utrUpdatedOn: statement.transactionPostedDate,
  //         weekNumber: currentWeek,
  //         approvalLevel: "",
  //       },
  //     ],
  //     acitData: [
  //       {
  //         docfy: parseInt(currentYear), // or Number(currentYear)
  //         docfm: parseInt(currentMonthMinus2), // or Number(currentMonthMinus2)
  //         doccc:
  //           statement.creditDebit === "DR"
  //             ? formData.transferFromCompanyCode
  //               ? parseInt(formData.transferFromCompanyCode)
  //               : null
  //             : formData.transferToCompanyCode
  //             ? parseInt(formData.transferToCompanyCode)
  //             : null,

  //         docitem: "10",
  //         postingkey: "",
  //         gl: "",
  //         amount: String(statement.transactionAmount),
  //         currency: formData.currency,
  //         debitcredit: statement.creditDebit === "DR" ? "D" : "C",
  //         reportinG_WBS: "TEST",
  //         transaction_Code: formData.transferType,
  //         client_WbsCode: "",
  //         resource_WbsCode: "",
  //         project_WbsCode: "",
  //         vendor_WbsCode: "",
  //         resource_dummy: "",
  //         material_WbsCode: "",
  //         bank: statement.housebankId,
  //         sales_InvoiceNo: "",
  //         cost_Center: "",
  //         account_Type: "",
  //         item_number_ref: "",
  //         clearing_status: "1",
  //       },
  //     ],
  //   };

  //   // try {
  //   //   console.log("Submitting payload:", payload);
  //   //   const res = await insertAchd(payload);
  //   //   console.log("API Response:", res);

  //   //   alert("STPL Transfer submitted successfully ✅");
  //   //   navigate(`/manual-Bank-reconciliation/${monthId}/${houseBankId}`);
  //   // } catch (err) {
  //   //   console.error("Error submitting transfer:", err);
  //   //   alert("❌ Failed to submit STPL Transfer. Please try again.");
  //   // }
  //   try {
  //     console.log("Submitting payload:", payload);
  //     const res = await insertAchd(payload);
  //     console.log("API Response:", res);

  //     // assuming backend returns { reconciliationId: "12345", ... }
  //     const recoId = res?.reconciliationId || res?.ReconciliationId;

  //     if (recoId) {
  //       alert(
  //         `STPL Transfer submitted successfully ✅\nReconciliation ID: ${recoId}`
  //       );
  //     } else {
  //       alert(
  //         "STPL Transfer submitted successfully ✅ (no ReconciliationId returned)"
  //       );
  //     }

  //     navigate(`/manual-Bank-reconciliation/${monthId}/${houseBankId}`);
  //   } catch (err) {
  //     console.error("Error submitting transfer:", err);
  //     alert("❌ Failed to submit STPL Transfer. Please try again.");
  //   }
  // };
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!statement) {
    alert("No statement data available. Cannot submit.");
    return;
  }

  // 🔹 Build the payload exactly as requested
  const payload = {
    statementId: statement.statementId,
    housebankId: statement.housebankId,
    transactionId: statement.transactionId,
    narration: statement.narration,
    creditDebit: statement.creditDebit,
    accountNumber: statement.accountNumber,

    // From statement
    Amount: statement.transactionAmount, // original transaction amount
    transactionDate: statement.valueDate,


    // From form
    transferType: formData.transferType,
    transferFrom: formData.transferFrom,
    transferFromCompanyCode: formData.transferFromCompanyCode,
    transferTo: formData.transferTo,
    transferToCompanyCode: formData.transferToCompanyCode,
    tAmount: formData.amount, // transfer amount entered by user
    currency: formData.currency,
    remarks: formData.remarks,
    userId:user?.userId
  };

  try {
    console.log("Submitting payload:", payload);
    const res = await insertAchd(payload);
    console.log("API Response:", res);

    // assuming backend returns { reconciliationId: "12345", ... }
    const recoId = res?.reconciliationId || res?.ReconciliationId;

    if (recoId) {
      alert(
        `STPL Transfer submitted successfully ✅\nReconciliation ID: ${recoId}`
      );
    } else {
      alert(
        "STPL Transfer submitted successfully ✅ (no ReconciliationId returned)"
      );
    }

    navigate(`/manual-Bank-reconciliation/${monthId}/${houseBankId}`);
  } catch (err) {
    console.error("Error submitting transfer:", err);
    alert("❌ Failed to submit STPL Transfer. Please try again.");
  }
};

  return (
    <div className="container mt-4">
      <h4>STPL Transfer Reconciliation</h4>
      {statement ? (
        <div className="card mt-3">
          <div className="card-header">
            <h5>Statement Details</h5>
          </div>
          <div className="card-body">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Statement ID</th>
                  <td>{statement.statementId}</td>
                </tr>
                <tr>
                  <th>House Bank ID</th>
                  <td>{statement.housebankId}</td>
                </tr>
                <tr>
                  <th>Transaction ID</th>
                  <td>{statement.transactionId}</td>
                </tr>
                <tr>
                  <th>Narration</th>
                  <td>{statement.narration}</td>
                </tr>
                <tr>
                  <th>Bank Name</th>
                  <td>{statement.bankName}</td>
                </tr>
                <tr>
                  <th>Credit/Debit</th>
                  <td>{statement.creditDebit}</td>
                </tr>
                <tr>
                  <th>Account Number</th>
                  <td>{statement.accountNumber}</td>
                </tr>
                <tr>
                  <th>Amount</th>
                  <td>{statement.transactionAmount}</td>
                </tr>
                <tr>
                  <th>Transaction Date</th>
                  <td>
                    {
                      statement.valueDate.split('T')[0]
                    }
                  </td>
                </tr>
              </tbody>
            </table>

            <Form onSubmit={handleSubmit}>
              <h5 className="mt-4">STPL Transfer Details</h5>

              <Form.Group className="mb-3">
                <Form.Label>Transfer Type</Form.Label>
                <Form.Select
                  name="transferType"
                  value={formData.transferType}
                  onChange={handleChange}
                  required
                >
                  <option value="I4">I4 - Internal</option>
                  <option value="I2">I2 - External</option>
                </Form.Select>
              </Form.Group>

              {/* <Form.Group className="mb-3">
                <Form.Label>Transfer From</Form.Label>
                <Form.Control
                  type="text"
                  name="transferFrom"
                  value={formData.transferFrom}
                  onChange={handleChange}
                  readOnly={statement?.creditDebit === "DR"} // prevent editing if auto-filled
                />
              </Form.Group> */}

              {/* <Form.Group className="mb-3">
                <Form.Label>Transfer From</Form.Label>
                {formData.transferFrom ? (
                  <Form.Control
                    type="text"
                    name="transferFrom"
                    value={formData.transferFrom}
                    readOnly
                  />
                ) : (
                  <Form.Select
                    name="transferFrom"
                    value={formData.transferFrom}
                    onChange={handleChange}
                  >
                    <option value="">Select House Bank</option>
                    {houseBanks.map((hb) => (
                      <option
                        key={hb.housebankId}
                        value={`${hb.housebankId} - ${hb.bankName} - ${hb.accountNumber}`}
                      >
                        {hb.housebankId} - {hb.bankName} - {hb.accountNumber}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </Form.Group> */}

              {/* <Form.Group className="mb-3">
                <Form.Label>Transfer From</Form.Label>
                <Form.Select
                  name="transferFrom"
                  value={formData.transferFrom}
                  onChange={handleChange}
                  disabled={statement?.creditDebit === "DR"} // only lock if auto-filled by DR
                >
                  <option value="">Select House Bank</option>
                  {houseBanks.map((hb) => (
                    <option
                      key={hb.housebankId}
                      value={`${hb.housebankId} - ${hb.bankName} - ${hb.accountNumber}`}
                    >
                      {hb.housebankId} - {hb.bankName} - {hb.accountNumber}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group> */}

              <Form.Group className="mb-3">
                <Form.Label>Transfer From</Form.Label>
                <Form.Select
                  name="transferFrom"
                  value={formData.transferFrom}
                  onChange={handleChange}
                  disabled={statement?.creditDebit === "DR"}
                >
                  <option value="">Select House Bank</option>
                  {houseBanks.map((hb) => (
                    <option key={hb.housebankId} value={hb.housebankId}>
                      {hb.housebankId} - {hb.bankName} - {hb.accountNumber}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Transfer From Company Code</Form.Label>
                <Form.Select
                  name="transferFromCompanyCode"
                  value={formData.transferFromCompanyCode}
                  onChange={handleChange}
                >
                  <option value="">Select Company</option>
                  {companies.map((c) => (
                    <option key={c.companyCode} value={c.companyCode}>
                      {c.companyCode} - {c.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* <Form.Group className="mb-3">
                <Form.Label>Transfer To</Form.Label>
                <Form.Control
                  type="text"
                  name="transferTo"
                  value={formData.transferTo}
                  onChange={handleChange}
                  readOnly={statement?.creditDebit === "CR"} // prevent editing if auto-filled
                />
              </Form.Group> */}

              {/* <Form.Group className="mb-3">
                <Form.Label>Transfer To</Form.Label>
                {formData.transferTo ? (
                  <Form.Control
                    type="text"
                    name="transferTo"
                    value={formData.transferTo}
                    readOnly
                  />
                ) : (
                  <Form.Select
                    name="transferTo"
                    value={formData.transferTo}
                    onChange={handleChange}
                  >
                    <option value="">Select House Bank</option>
                    {houseBanks.map((hb) => (
                      <option
                        key={hb.housebankId}
                        value={`${hb.housebankId} - ${hb.bankName} - ${hb.accountNumber}`}
                      >
                        {hb.housebankId} - {hb.bankName} - {hb.accountNumber}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </Form.Group> */}

              {/* <Form.Group className="mb-3">
                <Form.Label>Transfer To</Form.Label>
                <Form.Select
                  name="transferTo"
                  value={formData.transferTo}
                  onChange={handleChange}
                  disabled={statement?.creditDebit === "CR"} // only lock if auto-filled by CR
                >
                  <option value="">Select House Bank</option>
                  {houseBanks.map((hb) => (
                    <option
                      key={hb.housebankId}
                      value={`${hb.housebankId} - ${hb.bankName} - ${hb.accountNumber}`}
                    >
                      {hb.housebankId} - {hb.bankName} - {hb.accountNumber}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group> */}

              <Form.Group className="mb-3">
                <Form.Label>Transfer To</Form.Label>
                <Form.Select
                  name="transferTo"
                  value={formData.transferTo}
                  onChange={handleChange}
                  disabled={statement?.creditDebit === "CR"}
                >
                  <option value="">Select House Bank</option>
                  {houseBanks.map((hb) => (
                    <option key={hb.housebankId} value={hb.housebankId}>
                      {hb.housebankId} - {hb.bankName} - {hb.accountNumber}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Transfer To Company Code</Form.Label>
                <Form.Select
                  name="transferToCompanyCode"
                  value={formData.transferToCompanyCode}
                  onChange={handleChange}
                >
                  <option value="">Select Company</option>
                  {companies.map((c) => (
                    <option key={c.companyCode} value={c.companyCode}>
                      {c.companyCode} - {c.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Currency</Form.Label>
                <Form.Select
                  name="currency"
                  value={formData.currency}
                  onChange={handleChange}
                  required
                >
                  <option value="INR">INR</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </Form.Group>

              <Button variant="primary" type="submit">
                Submit STPL Transfer
              </Button>
            </Form>
          </div>
        </div>
      ) : (
        <div className="alert alert-warning">
          No statement data available. Please go back and select a statement.
        </div>
      )}
    </div>
  );
};

export default StplTransferReconciliation;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { Form, Button } from "react-bootstrap";
// import { getAllCompanyCodes } from "../Api/CompanyLocationMaster";

// const StplTransferReconciliation = () => {
//   const location = useLocation();
//   const { statement } = location.state || {};

//   const [companies, setCompanies] = useState([]);
//   const [formData, setFormData] = useState({
//     transferType: "INTERNAL",
//     transferFrom: "",
//     transferFromCompanyCode: "",
//     transferTo: "",
//     transferToCompanyCode: "",
//     amount: statement?.transactionAmount || "",
//     currency: "INR",
//     remarks: "",
//   });

//   // Fetch company codes
//   useEffect(() => {
//     const fetchCompanies = async () => {
//       try {
//         const res = await getAllCompanyCodes();
//         setCompanies(res || []); // ensure array
//       } catch (err) {
//         console.error("Error fetching company codes:", err);
//       }
//     };
//     fetchCompanies();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("STPL Transfer Data:", { ...formData, statement });
//     // Add your submission logic here
//   };

//   return (
//     <div className="container mt-4">
//       <h4>STPL Transfer Reconciliation</h4>
//       {statement ? (
//         <div className="card mt-3">
//           <div className="card-header">
//             <h5>Statement Details</h5>
//           </div>
//           <div className="card-body">
//             <table className="table table-bordered">
//               <tbody>
//                 <tr>
//                   <th>Statement ID</th>
//                   <td>{statement.statementId}</td>
//                 </tr>
//                 <tr>
//                   <th>House Bank ID</th>
//                   <td>{statement.housebankId}</td>
//                 </tr>
//                 <tr>
//                   <th>Transaction ID</th>
//                   <td>{statement.transactionId}</td>
//                 </tr>
//                 <tr>
//                   <th>Bank Name</th>
//                   <td>{statement.bankName}</td>
//                 </tr>
//                 <tr>
//                   <th>Credit/Debit</th>
//                   <td>{statement.creditDebit}</td>
//                 </tr>
//                 <tr>
//                   <th>Account Number</th>
//                   <td>{statement.accountNumber}</td>
//                 </tr>
//                 <tr>
//                   <th>Amount</th>
//                   <td>{statement.transactionAmount}</td>
//                 </tr>
//                 <tr>
//                   <th>Transaction Date</th>
//                   <td>
//                     {new Date(
//                       statement.transactionPostedDate
//                     ).toLocaleDateString()}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>

//             <Form onSubmit={handleSubmit}>
//               <h5 className="mt-4">STPL Transfer Details</h5>

//               <Form.Group className="mb-3">
//                 <Form.Label>Transfer Type</Form.Label>
//                 <Form.Select
//                   name="transferType"
//                   value={formData.transferType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="I4">I4 - Internal</option>
//                   <option value="I2">I2 - External</option>
//                 </Form.Select>
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Transfer From</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="transferFrom"
//                   value={formData.transferFrom}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Transfer From Company Code</Form.Label>
//                 <Form.Select
//                   name="transferFromCompanyCode"
//                   value={formData.transferFromCompanyCode}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Company</option>
//                   {companies.map((c) => (
//                     <option key={c.companyCode} value={c.companyCode}>
//                       {c.companyCode} - {c.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Transfer To</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="transferTo"
//                   value={formData.transferTo}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Transfer To Company Code</Form.Label>
//                 <Form.Select
//                   name="transferToCompanyCode"
//                   value={formData.transferToCompanyCode}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Company</option>
//                   {companies.map((c) => (
//                     <option key={c.companyCode} value={c.companyCode}>
//                       {c.companyCode} - {c.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Amount</Form.Label>
//                 <Form.Control
//                   type="number"
//                   name="amount"
//                   value={formData.amount}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Currency</Form.Label>
//                 <Form.Select
//                   name="currency"
//                   value={formData.currency}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="INR">INR</option>
//                   <option value="USD">USD</option>
//                   <option value="EUR">EUR</option>
//                 </Form.Select>
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Remarks</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={3}
//                   name="remarks"
//                   value={formData.remarks}
//                   onChange={handleChange}
//                 />
//               </Form.Group>

//               <Button variant="primary" type="submit">
//                 Submit STPL Transfer
//               </Button>
//             </Form>
//           </div>
//         </div>
//       ) : (
//         <div className="alert alert-warning">
//           No statement data available. Please go back and select a statement.
//         </div>
//       )}
//     </div>
//   );
// };

// export default StplTransferReconciliation;
